module.exports = __webpack_public_path__ + "static/media/img-download-app-zer0.d99b761b.png";